import { getAnalysisTypeDisplayName } from '@modules/dashboard/helpers';
import { useRemoveAnalysisFromDashboard } from '@modules/dashboard/hooks';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { RemoveCircleRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Stack, Typography } from '@mui/material';
import { AnalysisViewFragment } from 'generated/graphql';

interface DashboardQuantifyArchivedProps {
  analysis: AnalysisViewFragment;
}

export const DashboardArchivedAnalysis = ({
  analysis,
}: DashboardQuantifyArchivedProps) => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);

  const editToken = dashboard?.editToken;

  const { removeAnalysis, loading } = useRemoveAnalysisFromDashboard();

  const handleRemoveAnalysis = () => {
    if (!dashboard) {
      return;
    }
    removeAnalysis({
      dashboard: {
        ...dashboard,
        editToken: editToken ?? '',
      },
      analysis,
    });
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <Stack spacing={1} alignItems="center">
        <Typography variant="h2">🗃️</Typography>
        <Stack spacing={1.5} alignItems="center">
          <Typography variant="h6" color="text.secondary">
            This {getAnalysisTypeDisplayName(analysis.useCase)} has been
            archived
          </Typography>
          {Boolean(editToken) && (
            <LoadingButton
              variant="contained"
              onClick={handleRemoveAnalysis}
              startIcon={<RemoveCircleRounded />}
              loading={loading}
            >
              Remove
            </LoadingButton>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
